import { styled } from '@mui/system'
import { Box, InputLabel, Select, Stack, TextField } from '@mui/material'

const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '4px',
  '& fieldset': {
    borderColor: theme.palette.grey[300],
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[400],
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[400],
    borderWidth: 1,
  },
  '& .Mui-disabled': {
    WebkitTextFillColor: 'black',
    backgroundColor: 'whitesmoke',
  },
}))

const StyledInput = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '4px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.grey[300],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.grey[400],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.grey[400],
      borderWidth: 1,
    },
  },
}))

const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.grey[500],
  '&.Mui-focused': { color: theme.palette.primary.main },
}))

const StyledOptionStack = styled(Stack)({
  alignItems: 'center',
  flexDirection: 'row',
  gap: '1rem',
})

const StyledOptionBox = styled(Box)({
  display: 'flex',
  height: 15,
  width: 20,
})

export {
  StyledSelect,
  StyledInput,
  StyledInputLabel,
  StyledOptionStack,
  StyledOptionBox,
}
